/**
 * Стор общего (support) Telegram-аккаунта компании. DEV-1712.
 *
 * Только сессия: подключение по QR, 2FA, статус и отключение. Чаты общего
 * аккаунта сюда не тащим — это отдельная задача (DEV-1833).
 */
import { defineStore } from 'pinia'
import { telegramSupportApi } from '@/features/messenger/api/telegram.api'
import { createTelegramSession } from '@/features/messenger/stores/telegramSession'

export const useTelegramSupportStore = defineStore('telegram-support', () =>
  createTelegramSession({
    scope: 'support',
    api: {
      getStatus: telegramSupportApi.getStatus,
      startLogin: telegramSupportApi.startLogin,
      // login_id общего аккаунта один и известен серверу — в теле его нет.
      submitPassword: ({ password }) => telegramSupportApi.submitPassword({ password }),
      logout: telegramSupportApi.logout,
    },
  }),
)
